module.exports = __webpack_public_path__ + "static/img/4.56fb319.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/notice/4.png
// module id = Vj4I
// module chunks = 1